module.exports = __webpack_public_path__ + "static/media/thanRed.9dceef1d.svg";